import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

export const Wrapper = styled.div.withConfig({ componentId: 'sc-td4xf9-0' })`
    position: relative;
`;

export const ListWrapper = styled.div.withConfig({ componentId: 'sc-td4xf9-1' })`
    position: relative;
    overflow: hidden;
`;

interface ListProps {
  $scrollSnap?: boolean; // Used to disable scroll snap while using NavBtn for smooth scrolling to work in Safari
}

export const List = styled.ul.withConfig({ componentId: 'sc-td4xf9-2' })<ListProps>`
    display: flex;
    align-items: stretch;
    list-style: none;
    padding: 0;
    margin: 0;
    overflow: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }

    ${({ $scrollSnap }) =>
      $scrollSnap &&
      css`
            overflow: auto;
            scroll-snap-type: x mandatory;
            scroll-padding-left: 0;
        `}
`;

export const Item = styled.li.withConfig({ componentId: 'sc-td4xf9-3' })`
    flex: 1 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    scroll-snap-align: start;
    background-color: var(--c-contrast-bg);
    aspect-ratio: 16 / 9;
`;

export const Image = styled.img.withConfig({ componentId: 'sc-td4xf9-4' })`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const NavBtn = styled.div.withConfig({ componentId: 'sc-td4xf9-5' })`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
`;

export const PrevBtn = styled(NavBtn).withConfig({ componentId: 'sc-td4xf9-6' })`
    left: ${size(3)};
`;

export const NextBtn = styled(NavBtn).withConfig({ componentId: 'sc-td4xf9-7' })`
    right: ${size(3)};
`;
